import { useQuery, gql } from '@apollo/client'
import React from 'react'
import get from 'lodash/get'

import MobileGallery from '../../components/display/MobileGallery'

const GET_STORY_GALLERY = gql`
  query getStoryGallery($storyId: ID!) {
    story(id: $storyId) {
      listing: featuredListing {
        title
        price
        nicePricingSuffix
      }
      promoImage {
        large
      }
      featuredListingImage {
        large
      }
      photos {
        id
        image {
          large
        }
        aspectRatio
      }
      videos {
        id
        streamUrl
        thumbnailUrl
      }
    }
  }
`

const StoryMobileGallery = ({ storyId, ...props }) => {
  const { loading, data } = useQuery(GET_STORY_GALLERY, {
    variables: { storyId },
  })

  if (loading || !data) return null
  const { promoImage, featuredListingImage, photos, listing, videos } = get(
    data,
    'story'
  )
  const storyPhotos = [
    { image: { large: promoImage.large } },
    { image: { large: featuredListingImage.large } },
    ...photos,
  ]

  return (
    <MobileGallery
      photos={storyPhotos}
      videos={videos}
      listing={listing}
      {...props}
    />
  )
}

export default StoryMobileGallery
